export default class dadosProdutor {
  constructor(
    producer_id = "",
    producer_name = "",
    producer_tax_id = "",
    requester_id = null,
    requester_name = "null",
    requester_company_id = null,
    requester_company = "",
    requester_company_tax_id = null
  ) {
    this.producer_id = producer_id;
    this.producer_name = producer_name;
    this.producer_tax_id = producer_tax_id;
    this.requester_id = requester_id;
    this.requester_name = requester_name;
    this.requester_company_id = requester_company_id;
    this.requester_company = requester_company;
    this.requester_company_tax_id = requester_company_tax_id;
  }
}
